import { Editor } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import { Markdown } from "@tiptap/markdown";
import Link from "@tiptap/extension-link";

const RichTextEditor = {
  mounted() {
    this.input = document.getElementById(this.el.dataset.inputId);

    this.editor = new Editor({
      element: this.el,
      extensions: [StarterKit, Markdown, Link.configure({ openOnClick: false })],
      content: (this.input && this.input.value) || "",
      contentType: "markdown",
      onUpdate: ({ editor }) => {
        if (!this.input) return;
        this.input.value = editor.getMarkdown();
        this.input.dispatchEvent(new Event("input", { bubbles: true }));
      },
    });

    this.bindToolbar();
  },

  bindToolbar() {
    // Toolbar buttons live in the same wrapper as the editor container.
    const buttons = this.el.parentElement.querySelectorAll("[data-rte-action]");
    buttons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const chain = this.editor.chain().focus();
        switch (btn.dataset.rteAction) {
          case "h2":
            chain.toggleHeading({ level: 2 }).run();
            break;
          case "h3":
            chain.toggleHeading({ level: 3 }).run();
            break;
          case "bold":
            chain.toggleBold().run();
            break;
          case "italic":
            chain.toggleItalic().run();
            break;
          case "bullet":
            chain.toggleBulletList().run();
            break;
          case "ordered":
            chain.toggleOrderedList().run();
            break;
          case "link": {
            const url = window.prompt("Link URL");
            if (url) {
              chain.extendMarkRange("link").setLink({ href: url }).run();
            } else {
              chain.extendMarkRange("link").unsetLink().run();
            }
            break;
          }
        }
      });
    });
  },

  destroyed() {
    if (this.editor) {
      this.editor.destroy();
    }
  },
};

export default RichTextEditor;
